import p0 from './0.jpg'
import p1 from './1.jpg'
import p2 from './2.jpg'
import p3 from './3.jpg'
import p4 from './4.jpg'
import p5 from './5.jpg'
import p6 from './6.jpg'
import p7 from './7.jpg'
import p8 from './8.jpg'
import p9 from './9.jpg'
import p10 from './10.jpg'
import p11 from './11.jpg'
import p12 from './12.jpg'
import p13 from './13.jpg'
import p14 from './14.jpg'
import p15 from './15.jpg'
import p16 from './16.jpg'
import p17 from './17.jpg'
import p18 from './18.jpg'
import p19 from './19.jpg'
import p20 from './20.jpg'
import p21 from './21.jpg'
import p22 from './22.jpg'
import p23 from './23.jpg'
import p24 from './24.jpg'
import p25 from './25.jpg'
import p26 from './26.jpg'
import p27 from './27.jpg'
import p28 from './28.jpg'
import p29 from './29.jpg'
import p30 from './30.jpg'
import p31 from './31.jpg'
import p32 from './32.jpg'
import p33 from './33.jpg'
import p34 from './34.jpg'
import p35 from './35.jpg'
import p36 from './36.jpg'
import p37 from './37.jpg'
import p38 from './38.jpg'
import p39 from './39.jpg'
import p40 from './40.jpg'
import p41 from './41.jpg'
import p42 from './42.jpg'
import p43 from './43.jpg'
import p44 from './44.jpg'
import p45 from './45.jpg'
import p46 from './46.jpg'
import p47 from './47.jpg'
import p48 from './48.jpg'
import p49 from './49.jpg'
import p50 from './50.jpg'
import p51 from './51.jpg'
import p52 from './52.jpg'
import p53 from './53.jpg'
import p54 from './54.jpg'
import p55 from './55.jpg'
import p56 from './56.jpg'
import p57 from './57.jpg'
import p58 from './58.jpg'
import p59 from './59.jpg'
import p60 from './60.jpg'
import p61 from './61.jpg'
import p62 from './62.jpg'
import p63 from './63.jpg'

const images = [
  { key: 'p0', src: p0, width: 335, height: 368 },
  { key: 'p1', src: p1, width: 674, height: 368 },
  { key: 'p2', src: p2, width: 315, height: 368 },
  { key: 'p3', src: p3, width: 674, height: 368 },
  { key: 'p4', src: p4, width: 674, height: 368 },
  { key: 'p5', src: p5, width: 674, height: 368 },
  { key: 'p6', src: p6, width: 674, height: 368 },
  { key: 'p7', src: p7, width: 674, height: 368 },
  { key: 'p8', src: p8, width: 674, height: 368 },
  { key: 'p9', src: p9, width: 674, height: 368 },
  { key: 'p10', src: p10, width: 674, height: 368 },
  { key: 'p11', src: p11, width: 674, height: 368 },
  { key: 'p12', src: p12, width: 674, height: 368 },
  { key: 'p13', src: p13, width: 674, height: 368 },
  { key: 'p14', src: p14, width: 418, height: 312 },
  { key: 'p15', src: p15, width: 319, height: 284 },
  { key: 'p16', src: p16, width: 674, height: 368 },
  { key: 'p17', src: p17, width: 674, height: 368 },
  { key: 'p18', src: p18, width: 674, height: 368 },
  { key: 'p19', src: p19, width: 674, height: 368 },
  { key: 'p20', src: p20, width: 674, height: 368 },
  { key: 'p21', src: p21, width: 674, height: 368 },
  { key: 'p22', src: p22, width: 360, height: 365 },
  { key: 'p23', src: p23, width: 368, height: 367 },
  { key: 'p24', src: p24, width: 674, height: 368 },
  { key: 'p25', src: p25, width: 674, height: 368 },
  { key: 'p26', src: p26, width: 674, height: 368 },
  { key: 'p27', src: p27, width: 674, height: 368 },
  { key: 'p28', src: p28, width: 674, height: 368 },
  { key: 'p29', src: p29, width: 674, height: 368 },
  { key: 'p30', src: p30, width: 674, height: 368 },
  { key: 'p31', src: p31, width: 674, height: 368 },
  { key: 'p32', src: p32, width: 674, height: 368 },
  { key: 'p33', src: p33, width: 674, height: 368 },
  { key: 'p34', src: p34, width: 674, height: 368 },
  { key: 'p35', src: p35, width: 674, height: 368 },
  { key: 'p36', src: p36, width: 674, height: 368 },
  { key: 'p37', src: p37, width: 674, height: 368 },
  { key: 'p38', src: p38, width: 674, height: 368 },
  { key: 'p39', src: p39, width: 674, height: 368 },
  { key: 'p40', src: p40, width: 674, height: 368 },
  { key: 'p41', src: p41, width: 375, height: 375 },
  { key: 'p42', src: p42, width: 440, height: 440 },
  { key: 'p43', src: p43, width: 287, height: 175 },
  { key: 'p44', src: p44, width: 440, height: 440 },
  { key: 'p45', src: p45, width: 224, height: 225 },
  { key: 'p46', src: p46, width: 300, height: 168 },
  { key: 'p47', src: p47, width: 220, height: 302 },
  { key: 'p48', src: p48, width: 635, height: 635 },
  { key: 'p49', src: p49, width: 553, height: 311 },
  { key: 'p50', src: p50, width: 260, height: 260 },
  { key: 'p51', src: p51, width: 340, height: 227 },
  { key: 'p52', src: p52, width: 480, height: 240 },
  { key: 'p53', src: p53, width: 160, height: 160 },
  { key: 'p54', src: p54, width: 256, height: 256 },
  { key: 'p55', src: p55, width: 300, height: 301 },
  { key: 'p56', src: p56, width: 600, height: 336 },
  { key: 'p57', src: p57, width: 226, height: 226 },
  { key: 'p58', src: p58, width: 440, height: 440 },
  { key: 'p59', src: p59, width: 220, height: 302 },
  { key: 'p60', src: p60, width: 320, height: 320 },
  { key: 'p61', src: p61, width: 700, height: 350 },
  { key: 'p62', src: p62, width: 200, height: 200 },
  { key: 'p63', src: p63, width: 960, height: 960 }
]

export default images



// WEBPACK FOOTER //
// ./src/assets/poinkos/index.js